import styled from 'styled-components';
import styleUtils from '../../styles/style.utils';
import mediaBreakpoints from '../../styles/media-breakpoints';
import themedColor from '../../styles/theme/themed-color';
import themedFontSize from '../../styles/theme/themed-font-size';

const StyledForm = styled.form`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;

  & > *:last-child {
    flex: 1 0 auto;
  }
`;

const TopLine = styled.div`
  width: 100%;
  max-width: ${styleUtils.size('MAX_CONTAINER_WIDTH')};
  margin: 0 auto ${styleUtils.px(48)};

  display: flex;
  flex-direction: column;

  ${mediaBreakpoints.greaterThan('M')`    
    flex-direction: row;
    
    & > div {
      flex-basis: 50%;
    }
  `};
`;

const FetchErrorMessage = styled.div`
  font-size: ${themedFontSize('BODY')};
  color: ${themedColor('ERROR')};
  text-align: center;
  max-width: ${styleUtils.px(900)};
  margin: ${styleUtils.px(-35)} auto ${styleUtils.px(50)} auto;
  padding: 0 ${styleUtils.px(20)};
`;

const ContactFormComponents = { TopLine, FetchErrorMessage, StyledForm };

export default ContactFormComponents;
